<template>
  <vs-popup class="sundry-item-stock-popup" title="ADJUST SUNDRY ITEM STOCK" @close="open = false" :active.sync="open"
    :buttons-hidden="true">
    <vx-card no-shadow>

      <div class="vx-row" id="sundry-item-stock-popup">
        <div class="vx-col lg:w-full w-full">
          <vs-table noDataText="">
            <template>
              <vs-tr>
                <vs-td class="font-semibold" width="50%">ITEM CODE</vs-td>
                <vs-td>{{ createForm.sundry_item_code || '' }}</vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td class="font-semibold">PROD CODE</vs-td>
                <vs-td>{{ createForm.sundry_product_code || '' }}</vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td class="font-semibold">PROD NAME</vs-td>
                <vs-td>{{ createForm.sundry_product_name || '' }}</vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td class="font-semibold">SUPPLIER</vs-td>
                <vs-td>{{ createForm.sundry_supplier || '' }}</vs-td>
              </vs-tr>

            </template>
          </vs-table>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col lg:w-full w-full">
          <vs-table noDataText="">
            <template>
              <vs-tr>
                <vs-td class="font-semibold" width="50%">CURRENT STOCK LEVEL (ITEM)</vs-td>
                <vs-td class="text-lg font-bold text-primary">{{ toFixed(createForm.current_stock_level) }}</vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td class="font-semibold">AVAILABLE UNALLOCATED STOCK (ITEM)</vs-td>
                <vs-td class="text-lg font-bold text-primary">{{ toFixed(createForm.available_unallocated_stock) }}</vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td class="font-semibold">CONFIRMED ORDER STOCK ALLOCATION (ITEM)</vs-td>
                <vs-td class="text-lg font-bold text-primary">{{ toFixed(createForm.confirmed_order_stock_allocation) }}</vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td class="font-semibold">LOW STOCK THRESHOLD (KG)</vs-td>
                <vs-td class="text-lg font-bold text-primary">{{ createForm.is_low_stock_threshold_required ? toFixed(createForm.low_stock_threshold) : 'Not set' }}</vs-td>
              </vs-tr>

            </template>
          </vs-table>
        </div>
      </div>
      <div class="vx-row mt-8">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
          <label class="text-sm opacity-100 text-bold">View By Sundry Stock Status</label>
          <v-select :clearable="true" placeholder="" v-model="filters['status']"
            :options="['In_Stock', 'Out_of_Stock', 'Expired']" :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card no-shadow class="pt-4">
            <!-- <template slot="actions">
              <vs-button @click="onClickCreate()" class="mr-4 mb-4" color="primary" type="filled">Create a Sundry Item
                Stock</vs-button>
            </template> -->
            <div slot="no-body" class="mt-4">
              <vs-table id="sundry-item-list-table" :max-items="(meta.per_page) ? meta.per_page : 10" :data="items" sort
                :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

                <template slot="thead">
                  <vs-th width="15%" class="text-sm">BATCH NO</vs-th>
                  <vs-th width="10%" class="text-sm" sort-key="sundry_item_code">SUNDRY PRODUCT CODE</vs-th>
                  <vs-th width="10%" class="text-sm" sort-key="sundry_product_code">SUNDRY PRODUCT NAME</vs-th>
                  <vs-th width="5%" class="text-sm">LOCATION</vs-th>
                  <vs-th width="10%" class="text-sm">SUPPLIER</vs-th>
                  <vs-th width="10%" class="text-sm">TOTAL QTY (Kg)</vs-th>
                  <vs-th width="10%" class="text-sm">AVAILABLE QTY (Kg)</vs-th>
                  <vs-th width="10%" class="text-sm">STATUS</vs-th>
                  <vs-th width="10%" class="text-sm">ACTION</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr @click.native="onClickUpdateSundryStock(data[indextr])" class="text-sm" style="cursor: pointer"
                    :key="indextr" v-for="(tr, indextr) in data">


                    <vs-td class="text-primary font-semibold" :data="data[indextr].code">
                      {{ data[indextr].code || 'N/A'}}
                    </vs-td>

                    <vs-td :data="data[indextr].sundry_item_code">
                      {{ data[indextr].sundry_item_code }}
                    </vs-td>

                    <vs-td :data="data[indextr].sundry_product_name">
                      {{ data[indextr].sundry_product_name }}
                    </vs-td>

                    <vs-td>
                      {{ data[indextr].location || 'N/A' }}
                    </vs-td>

                    <vs-td>
                      {{ data[indextr].supplier }}
                    </vs-td>

                    <vs-td :data="data[indextr].total_quantity">
                      {{ data[indextr].total_quantity }}
                    </vs-td>

                    <vs-td :data="data[indextr].available_quantity">
                      {{ data[indextr].available_quantity }}
                    </vs-td>

                    <vs-td :data="data[indextr].status">
                      <vs-chip transparent :color="'dark'" style="border-radius: 0" class="w-32">
                        {{ data[indextr].status | stock_status_format }}
                      </vs-chip>
                    </vs-td>


                    <vs-td>
                      <div class="vx-row">
                        <vx-tooltip text="View/Update sundry stock" position="left" class="mr-2">
                          <vs-button class="ml-3" @click.stop="onClickUpdateSundryStock(data[indextr])" size="small"
                            color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip class="flex justify-start mr-2"
                          text="View qc test" position="top" v-can="'create-edit-sundry-orders-qc-test'">
                          <vs-button class="flex justify-end" @click.stop="onClickUpdateQcTest(data[indextr].q_c_test)"
                            size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                        </vx-tooltip>
                      </div>
                    </vs-td>

                  </vs-tr>
                </template>


              </vs-table>

              <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
                :max-items="perPage" description-body="Rows per page" description-connector="of"
                description-title="Records" description :description-items="descriptionItems"
                :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
              </vs-pagination>


            </div>
          </vx-card>
        </div>
      </div>
    </vx-card>
    <update-sundry-stock-pop-up v-on:refreshData="refreshData" ref="updateSundryStockPopUp" />
    <view-qc-test-sundry-order-item-pop-up ref="viewQcTestSundryOrderItemPopUp"/>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const InventoryRepository = RepositoryFactory.get('inventory')
import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import Filter from '@/mixins/filter';
import UpdateSundryStockPopUp from "@/components/popups/inventory/stock/sundry/UpdateSundryStockPopUp";
import ViewQcTestSundryOrderItemPopUp from '@/components/popups/sundry-suppliers/sundry-item-orders/qc-tests/ViewQcTestSundryOrderItemPopUp.vue'

const ManufacturingRepository = RepositoryFactory.get('manufacturing')
import { defaultPagination, perPageList } from "@/constants/config";


function initialState() {
  return {
    open: false,
    id: '',
    items: [],
    filters: {},
    page: 1,
    total: 0,
    meta: {},
    sort: '',
    perPage: defaultPagination,
    descriptionItems: perPageList,
    createForm: '',
    sundry_item_code: ''
  }
}

export default {
  name: 'UpdateSundryItemStockPopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(id) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = id
        this.open = true;
        await this.fetchSundryStock()
      } catch (error) {

      }
    },
    async refreshData() {
      await this.fetchSundryStock()
    },
    async fetchSundryStock() {
      await this.$vs.loading({
        container: '#sundry-item-stock-popup',
        scale: 0.45
      })
      try {
        const { data } = (await InventoryRepository.getSundryItemStock(this.id)).data
        this.createForm = data
        this.sundry_item_code = this.createForm.sundry_item_code
        await this.fetchSundryStockInventory()
      } catch (error) {

      }
      this.$vs.loading.close('#sundry-item-stock-popup > .con-vs-loading')
    },
    async fetchSundryStockInventory() {
      await this.$vs.loading({
        container: '#sundry-item-stock-popup',
        scale: 0.45
      })
      try {
        const { data } = await ManufacturingRepository.getSundryInventory(this.page, this.perPage, `filter[search]=${this.sundry_item_code}&${this.filterQuery}`)
        this.items = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#sundry-item-stock-popup > .con-vs-loading')
    },
    onClickUpdateSundryStock(data) {
      this.$refs.updateSundryStockPopUp.openPopup(data.id)
    },
    async onClickUpdateQcTest(data) {
      await this.$refs.viewQcTestSundryOrderItemPopUp.openPopup(data)
    },
    filterQueryUpdate() {
      this.fetchSundryStockInventory()
    },

    handleChangePage(page) {
      this.page = page;
      this.fetchSundryStockInventory()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchSundryStockInventory()
      }

    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    toFixed(number) {
      return number
      // return Number(number).toFixed(4)
    },
    closePopup() {
      this.open = false
    },
  },
  async mounted() {

  },
  components: {
    'v-select': vSelect,
    UpdateSundryStockPopUp,
    ViewQcTestSundryOrderItemPopUp
  },
  mixins: [SuccessMessage, ErrorMessages, Filter],
  watch: {
    page() {
      this.fetchSundryStockInventory()
    },
    perPage() {
      this.fetchSundryStockInventory()
    },
  }
}
</script>

<style scoped>
.sundry-item-stock-popup>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 60% !important;
}
</style>
